import { setExecutiveSummaryMessage } from '../ExecutiveSummary/ExecutiveSummaryActions';
import fetchWithDefaults from '../CommonUtils/fetchWithDefaults';
import { urlWithParams } from '../CommonUtils/urlWithParams';
import { MESSAGES } from '../CommonConstants';

export const SUMMARY_SET = 'CONSUMER_OVERVIEW.SUMMARY_SET';
export const ERRORS_SET = 'CONSUMER_OVERVIEW.ERRORS_SET';

export const setSummary = payload => ({
  type: SUMMARY_SET,
  payload,
});

export const setErrors = payload => ({
  type: ERRORS_SET,
  payload,
});

export const fetchSummary = clientId => async dispatch => {
  try {
    const response = await fetchWithDefaults(urlWithParams('/Consumer/Summary', { clientId }), {
      showSpinner: true,
    });
    const { success, payload, errors } = await response.json();

    if (success) {
      dispatch(setSummary(payload.viewData));
      dispatch(setExecutiveSummaryMessage(payload.viewData.Summary));
    }

    dispatch(setErrors(success ? [] : errors));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    dispatch(setErrors([MESSAGES.GENERIC_ERROR]));
  }
};
